import { ChangeDetectorRef, Component, effect, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { EMPTY, Observable, of, Subject } from 'rxjs';
import { debounceTime, map, switchMap, takeUntil } from 'rxjs/operators';
import { CouponEnum, PayoffEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import { ProductUtils } from 'src/app/product-capture/utils/product.utils';
import { CreateProductComponent } from '../../create-product.component';

@Component({
  selector: 'app-key-dates-data',
  templateUrl: './key-dates-data.component.html',
  styleUrls: ['./key-dates-data.component.scss']
})
export class KeyDatesDataComponent {

  form: UntypedFormGroup;

  private destroy$ = new Subject();

  summaryForm: UntypedFormGroup;

  payoffForm: UntypedFormGroup;

  productPaysCoupon: Signal<boolean>;  

  constructor(
    private createProductComponent: CreateProductComponent,
    private cdr: ChangeDetectorRef
  ) {  
    this.summaryForm = this.createProductComponent.getFormByKey('summary');
    this.payoffForm = this.createProductComponent.getFormByKey('payoff');
    this.form = this.summaryForm.get('keyDates') as UntypedFormGroup;

    this.form.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(200)
      )
      .subscribe(() => {
        this.disableCustomFields();
      });

    this.productPaysCoupon = 
      toSignal(this.payoffForm.get(PayoffEnum.coupon)
        .get(CouponEnum.couponType).valueChanges
        .pipe(
          takeUntil(this.destroy$),
          map(couponType => couponType !== 'NONE')
        )
      );

    effect(() => {
      if (this.productPaysCoupon()) {
        this.form.get('interestStartDate').disable();
        this.form.get('interestEndDate').disable();
      }
    })
  }

  createObserverForField(control: AbstractControl): Observable<UntypedFormControl> {
    return control.valueChanges.pipe(
      debounceTime(200),
      switchMap((value: any) => value ? of(control as UntypedFormControl) : EMPTY));
  }

  disableCustomFields(): void {
    setTimeout(() => {
      const fields = ['issueDate', 'redemptionDate', 'initialObservationDate', 'finalObservationDate', 'interestStartDate', 'interestEndDate'];
      fields.forEach((field: string) => this.form.get(field)['readOnlyKeyDates'] = true);

      this.cdr.detectChanges();
    });
  }

  get productRequiresUnderlyingAsset(): boolean {
    const { underlyingAssetsGroup, productType } = this.summaryForm.controls;
    return !underlyingAssetsGroup.disabled && !ProductUtils.isFxPair(productType.value)
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
